import store from "../../../store";
import api_export from './api_export.vue';

window.api_export =  new Vue({
    store,
    el: 'div#api_export',

    name : "api_export",
    data () {
        return {

        }
    },
    created () {

    },
    components : {
        api_export,
    }
});
